export default __webpack_public_path__ + "static/media/logo-toolscatalog.cc30dce7.svg";